module.exports = __webpack_public_path__ + "static/media/main_visual_newag_mlt_630_115_v.e7faf4be.png";